// Multivariate Dependencies
import React from 'react';
// Components
import { Container } from '../../../common/styles/container/styles/Container';
import { IconContainer } from '../styles/IconContainer';
// Utils
import { classNames } from 'ezyvet-fe-helpers';
// Types
import { keepFocusOnDropdownInput } from '../types/keepFocusOnDropdownInput';
export var InteractableIconContainer = function (_a) {
    var icon = _a.icon, hoverEffects = _a.hoverEffects, gridColumn = _a.gridColumn, color = _a.color, ariaLabel = _a.ariaLabel, onClick = _a.onClick, className = _a.className;
    return (React.createElement(Container
    /**
     * Set to -1 to prevent the user from tabbing into this element but allowing the element
     * to appear as a related target of an onBlur event
     */
    , { 
        /**
         * Set to -1 to prevent the user from tabbing into this element but allowing the element
         * to appear as a related target of an onBlur event
         */
        tabIndex: -1, className: classNames([keepFocusOnDropdownInput, className]), gridColumn: gridColumn, width: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', outline: 'none', color: color, hoverEffects: hoverEffects, onClick: onClick },
        React.createElement(IconContainer, { ariaLabel: ariaLabel, name: icon })));
};
//# sourceMappingURL=InteractableIconContainer.js.map